import { FC, PropsWithChildren } from 'react';

import { MitarbeiterRole } from '../api/types';

import { VisibleIfRole } from './VisibleIfRole';

export const VisibleIfAdmin: FC<PropsWithChildren> = ({ children }) => (
  <VisibleIfRole equals={MitarbeiterRole.ADMIN}>{children}</VisibleIfRole>
);
